import { FC } from 'react';

import styled from 'styled-components';

import { TourPackageDetailProgramViewModel } from '@api/index';
import { SectionHeading } from '@shared/SectionHeading';

import TourTimeline from '../../components/TourTimeline/TourTimeline';
import { CardContainer } from '../styled';
import { useTourDetailState } from '../../detail/context';

const Wrapper = styled.div`
  margin-bottom: 20px;
`;

const Container = styled(CardContainer)`
  background: transparent;
  padding-left: 4px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    padding-top: 0;
  }

  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    padding-left: 8px;
    padding-right: 16px;
  }
`;

const TitleContainer = styled.div`
  margin-bottom: 36px;

  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    margin-bottom: 26px;
  }
`;

const Title = styled(SectionHeading)`
  margin-bottom: 0;
`;

export interface TourItineraryProps {
  data: TourPackageDetailProgramViewModel[];
}

const TourItinerary: FC<TourItineraryProps> = ({ data }) => {
  const state = useTourDetailState();
  return (
    <Wrapper>
      <Container>
        <div style={{ width: '100%' }}>
          <TitleContainer>
            <Title>{state.resource} Programı</Title>
          </TitleContainer>
          <TourTimeline data={data} />
        </div>
      </Container>
    </Wrapper>
  );
};

export default TourItinerary;
